export class ItemGroup {
  ItemGroupId: number;
  Description: string;
  Brand: string;
  PurchaseDiscount: number;
  Notes: string;
  Properties: { [key: string]: any; };
}